import { Component, Input } from '@angular/core';
import { OrganizationConfigService } from '../../../../../services/organization-config/organization-config.service';
import {
  dateStringFromISO8601,
  getStaffNameDisplay,
  timeStringFromISO8601,
} from '../../../../../utils';


@Component({
  selector: 'app-last-updated-by-footer',
  templateUrl: './last-updated-by-footer.component.html',
})
export class LastUpdatedByFooterComponent {
  @Input() updatedAt: string;
  @Input() firstName: string | null = null;
  @Input() lastName: string | null = null;
  @Input() email: string | null = null;

  public readonly dateStringFromISO8601 = dateStringFromISO8601;
  public readonly timeStringFromISO8601 = timeStringFromISO8601;
  public readonly getStaffNameDisplay = getStaffNameDisplay;

  constructor(public orgConfig: OrganizationConfigService) {}

  get hasStaffUser(): boolean {
    return !!(this.firstName || this.lastName || this.email);
  }
}
